//@flow
import { HiverAxios, setHiddenLoadingBar } from 'h-commons';
import {
    GET_PAYMENT_HISTORY_DONE,
    GET_PAYMENT_HISTORY_FAILED,
    GET_PAYMENT_HISTORY_INIT
} from '../actions';

export const getPaymentHistory = (hidden) => (dispatch: Function) => {
    dispatch({
        type: GET_PAYMENT_HISTORY_INIT
    });
    hidden && dispatch(setHiddenLoadingBar(true));
    HiverAxios({
        url: '/api/account/payment',
        type: 'GET',
        callback: response => {
            if (response.data && response.data.success) {
                dispatch({
                    type: GET_PAYMENT_HISTORY_DONE,
                    payload: response.data.data
                });
            } else {
                dispatch({
                    type: GET_PAYMENT_HISTORY_FAILED
                });
            }
            hidden && dispatch(setHiddenLoadingBar(false));
        },
        onfail: () => {
            dispatch({
                type: GET_PAYMENT_HISTORY_FAILED
            });
            hidden && dispatch(setHiddenLoadingBar(false));
        }
    })
}